export enum TransportationPaymentsStatus {
  ALL = 'ALL',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  PAID = 'PAID'
}
